export const ApplePayUtils = {
  APPLE_PAY: 'AP',
  isEnabled: () => {
    if (window.isExpressCheckoutOnMobileAppsEnabled) {
      return true;
    }

    return (
      (window.ApplePaySession && window.ApplePaySession.canMakePayments()) ===
      true
    );
  },
};
